import { createContext } from 'solid-js';
export const AppControllerContext = createContext();
